module.exports = __webpack_public_path__ + "static/media/café coletivo.edcd4391.jpg";